import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ReactPlayer from "react-player";
import styled from "styled-components";
// import { WmkLink } from "wmk-link";
import { VideoHeroQuery } from "../../fragments/NodeVideoHeroFields";
import { colors } from "./colors";
import HeroBackgroundVector from "./HeroVectors/HeroBackroundVector";
import { Typography } from "./Typography";
import { buttonStyles } from "./Buttons/WmkButton";
import MobileHeroBackgroundVector from "./HeroVectors/MobileHeroBackgroundVector";
import FormPopup from "./FormPopup";
import { VideoFormQuery } from "../../fragments/NodeVideoFormFields";
import { FormContext } from "../context/FormContext";

const WatermarkButtonWhite = styled.div`
  // position: absolute;
  // bottom: 0;
  & > div {
    display: flex !important;
    width: 100%;
    text-align: center;
    color: ${colors.accentOrange.getHex()};
    cursor: pointer;
  }
  button {
    ${buttonStyles};
    background: white;
    color: ${colors.accentOrange.getHex()};
    width: 18.7rem;
  }
`;

const VideoHeroContainer = styled(Container)<{ width: number }>`
  background: linear-gradient(90deg, #ca2b2b 0%, #ff9200 100%);
  position: relative;
  padding: 3rem 10vw;
  svg {
    position: absolute;
    width: 100%;
    // opacity: 0.2;
    top: -5%;
    left: 0;
    ${({ width }) => (width ? `height: calc(${width} / 1382 * 535px)` : ``)}
  }
  .heading-col {
    text-align: center;
    margin-bottom: 4rem;
  }
  .text-col {
    color: ${colors.white.getHex()};
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: space-between;
  }
  .video-col {
    z-index: 1;
    // width: 100%;
    padding-right: 0;
    padding-left: 0;
  }
  @media screen and (max-width: 576px) {
    svg {
      top: 0;
      height: auto;
    }
  }
  @media screen and (max-width: 990px) {
    padding: 0 0 2rem;
    .text-col {
      padding: 2rem 10vw;
    }
    .video-col {
    }
  }
`;

const VideoHero = ({
  videoHeroData,
  videoForm
}: // isOpen,
// openToggle
{
  videoHeroData: VideoHeroQuery;
  videoForm: VideoFormQuery;
  // isOpen: boolean;
  // openToggle: Function;
}) => {
  const [viewWidth, setViewWidth] = useState(0);
  const [videoWidth, setVideoWidth] = useState(0);
  // const [isOpen, setIsOpen] = useState(false);
  const videoRef = useRef<HTMLDivElement>(null);

  // const toggle = () => {
  //   setIsOpen(!isOpen);
  // };

  useEffect(() => {
    handleResize();
    setTimeout(() => {
      handleResize();
    }, 0);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    const current = videoRef.current;
    const winWidth = window.innerWidth;
    const rect = current ? current.getBoundingClientRect() : null;
    if (rect) {
      setVideoWidth(rect.width);
    }
    setViewWidth(winWidth);
  };

  const largeDisplay = viewWidth > 990;

  const getMobile = () => {
    return (
      <>
        <Row style={{ marginRight: 0, marginLeft: 0 }}>
          <Col className="video-col" ref={videoRef}>
            <ReactPlayer
              url={videoHeroData?.video?.videoLink}
              width={"100%"}
              height={videoWidth * 0.5275}
            />
          </Col>
        </Row>
        <Row style={{ width: "100%" }}>
          <Col className="text-col">
            {viewWidth > 575 ? (
              <HeroBackgroundVector width={viewWidth.toString()} />
            ) : (
              <MobileHeroBackgroundVector width={viewWidth.toString()} />
            )}
            <div>
              <Typography.H3 style={{ fontSize: "36px" }}>
                {videoHeroData.copyHeader}
              </Typography.H3>
              <Typography.P style={{ fontSize: "24px", marginBottom: "2rem" }}>
                {videoHeroData.copy}
              </Typography.P>
            </div>
            <FormContext.Consumer>
              {(formContextData) => {
                return (
                  <WatermarkButtonWhite
                    onClick={() => {
                      formContextData.toggleIsOpen();
                    }}>
                    <button>{videoHeroData.link.linkText}</button>
                  </WatermarkButtonWhite>
                );
              }}
            </FormContext.Consumer>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <VideoHeroContainer fluid width={viewWidth}>
      <FormPopup videoForm={videoForm} />
      {largeDisplay && (
        <>
          <HeroBackgroundVector />
          <Row>
            <Col className="heading-col">
              <Typography.BLOCKQUOTE
                style={{ fontFamily: "Rajdhani", fontSize: "18px", margin: 0 }}>
                {videoHeroData.subheading}
              </Typography.BLOCKQUOTE>
              <Typography.H2
                style={{ color: colors.white.getHex(), fontSize: "40px" }}>
                {videoHeroData.heading}
              </Typography.H2>
            </Col>
          </Row>
        </>
      )}
      {largeDisplay ? (
        <Row>
          <Col className="text-col" xs={12} lg={{ span: 4 }}>
            <>
              {/* {viewWidth > 766 && (
                <HeroBackgroundVector width={viewWidth.toString()} />
              )} */}
              <div>
                <Typography.H3 style={{ fontSize: "36px" }}>
                  {videoHeroData.copyHeader}
                </Typography.H3>
                <Typography.P
                  style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  {videoHeroData.copy}
                </Typography.P>
              </div>
              <FormContext.Consumer>
                {(formContextData) => {
                  return (
                    <WatermarkButtonWhite
                      onClick={() => {
                        formContextData.toggleIsOpen();
                      }}>
                      <button>{videoHeroData.link.linkText}</button>
                    </WatermarkButtonWhite>
                  );
                }}
              </FormContext.Consumer>
              {/* <WatermarkButtonWhite
                onClick={() => {
                  openToggle();
                }}>
                <button>{videoHeroData.link.linkText}</button>
              </WatermarkButtonWhite> */}
            </>
          </Col>
          <Col
            xs={12}
            lg={{ span: 6, offset: 2 }}
            className="video-col"
            ref={videoRef}>
            <ReactPlayer
              url={videoHeroData?.video?.videoLink}
              width={"100%"}
              height={videoWidth * 0.5275}
            />
          </Col>
        </Row>
      ) : (
        getMobile()
      )}
    </VideoHeroContainer>
  );
};

export default VideoHero;
